export const transformItemAlertDto = itemAlert => ({
  itemAlertType: itemAlert.item_alert_type,
  detailedDescription: itemAlert.detailed_description,
  photoTipId: itemAlert.photo_tip_id || null,
  shortDescription: itemAlert.short_description || null
});